import React, { useState, useEffect } from 'react';
import './CSS/HomeLowerPage.css';
import { BrowserView, MobileView } from 'react-device-detect';
import { RiArrowDropDownLine, RiArrowDropRightLine } from 'react-icons/ri'


const HomeLowerPage = () => {
  const [titles, setTitles] = useState({
    education: [
      { title: "Master's in Computer Science", subTitles: [
        {"text": "University of Glasgow Faster Route programme, equivalent to BAC+5"},
        {"text": "Coursework: Machine Learning, Advanced Statistics, Maths, AI, Python, C#/C/C++, Big Data, and Data Processing"},
        {"text": "Bachelor's dissertation: Speeding up spaceship search in Conway's Game of Life using deep learning"},
        {"text": "Master's dissertation: Inferring phylogenetic trees using deep reinforcement learning"},
        {"text": "Grade: 16.36/20, First Class"},
        {"text": "Computer Science Faster Route", "link":"https://www.gla.ac.uk/undergraduate/degrees/computingscience/#coursedetails"}
      ], clicked: false },
      { title: "A-levels and BAC", subTitles: [
        {"text": "CIE A-levels: Maths (A*), Computer Science (A*) and Physics (A*)"},
        {"text": "French BAC: 19.5/20, Tres bien avec felicitations du jury"},
        {"text": "International School of Bearn", "link": "https://www.isbearn.com/"}
      ], clicked: false },
      { title: "Technical strengths", subTitles: [
        {"text": "Languages: Python, Java, JavaScript, C#, C/C++, KDB/Q, SQL, and Bash"},
        {"text": "Backend: Spring, .NET, Django, FastAPI, Micronaut, DropWizard, Kafka, and Spark"},
        {"text": "DevOps: Kubernetes, Docker, GitLab/GitHub pipelines, Terraform, AWS, Prometheus, and Selenium"},
        {"text": "Data and finance: PyTorch, TensorFlow, Pandas, time series analysis, market pricing, and portfolio optimisation"}
      ], clicked: false }
    ],
    experience: [
      { title: "Paul Bekaert Consulting", subTitles: [
        {"text": "Building an automatic AI YouTube animation tool using React, FastAPI, LLMs, and Copilot"},
        {"text": "Created websites for 5+ clients using React, .NET/C#, FastAPI, Docker, CI/CD, and SEO"},
        {"text": "Consulted on media and engineering concepts for the European Commission and European Council"}
      ], clicked: false },
      { title: "Goldman Sachs - Software Engineering Analyst", subTitles: [
        {"text": "Built Spark and Kafka P&L calculators for 10+ asset types, reducing batch processing from 14 hours to 2"},
        {"text": "Built endpoints for thousands of clients and automated REST API/calculator deployments to Kubernetes on GitLab"},
        {"text": "SME for the Controllers website with React, DropWizard, Docker, and Kubernetes"},
        {"text": "Integrated Selenium testing and rebuilt the pipeline to automate testing and deployment in under 30 minutes"},
        {"text": "Expanded Prometheus prober/SRE infrastructure with SLI metrics and Terraform-driven notifications"},
        {"text": "Goldman Sachs Website", "link": "https://www.goldmansachs.com/"}
      ], clicked: false },
      { title: "GUSS - Team Lead Software Engineer", subTitles: [
        {"text": "Led a team of 3 across client-facing websites, apps, and research software projects"},
        {"text": "Worked on genome evolution tree prediction with TensorFlow and SciPy, React websites, and Rust/C++ games"},
        {"text": "Glasgow University Software Service", "link": "https://www.gla.ac.uk/schools/computing/industry/glasgowuniversitysoftwareserviceguss/"}
      ], clicked: false},
      { title: "Goldman Sachs - Software Engineering Intern", subTitles: [
        {"text": "Developed SRE software for the Controllers website using Kubernetes, Micronaut, and Prometheus"},
        {"text": "Gained fintech, markets, and debt asset P&L pricing model experience"},
        {"text": "Goldman Sachs Website", "link": "https://www.goldmansachs.com/"}
      ], clicked: false },
      { title: "JPMorgan - Software Engineering Intern", subTitles: [
        {"text": "Enhanced a real-time market price website using AG Grid, React, and Spring Boot"},
        {"text": "Built enterprise-level code using Agile, TDD, Confluence, and Jira"},
        {"text": "JPMorgan Website", "link": "https://www.jpmorgan.com/"}
      ], clicked: false },
      { title: "Research Assistant", subTitles: [
        {"text": "Co-writer of \"Are Thermal Attacks a Realistic Threat? Investigating the Preconditions of Thermal Attacks in Users' Daily Lives\", published in NordCHI '22"},
        {"text": "Link to paper", "link" : "https://dl.acm.org/doi/10.1145/3546155.3546706"},
        {"text": "Built a proof-of-concept music sharing social media app in Android Studio"},
        {"text": "University of Glasgow Website", "link": "https://www.gla.ac.uk/"}
      ], clicked: false }
    ],
    achievements: [
      { title: "Independent finance projects", subTitles: [
        {"text": "Built a C# live P&L calculator for equities, commodities, and derivatives using Kafka"},
        {"text": "Created a SABR volatility surface model in C# using live market data"},
        {"text": "Implemented options pricing, Heston simulations, Black-Scholes/binomial calculators, and portfolio optimisation models"},
        {"text": "Built an execution strategy simulator with orderbook, slippage modelling, and execution logic"}
      ], clicked: false },
      { title: "Competitions", subTitles: [
        {"text": "2nd place in a Goldman Sachs LLM marathon"},
        {"text": "1st place in the Cisco IoT Solutions Marathon"},
        {"text": "3rd place in a GUTS hackathon for a full-stack React and NodeJS website"}
      ], clicked: false },
      { title: "University clubs", subTitles: [
        {"text": "Head of Flight Systems at GU Rocketry"},
        {"text": "Head of the Cards Society"},
        {"text": "Veteran member of GU Chess Club"}
      ], clicked: false },
      { title: "Interests", subTitles: [
        {"text": "Investing, financial markets, geopolitics, travelling, chess, AI, poker, economics, and space/rocketry"}
      ], clicked: false },
    ],
  });

  const handleItemClick = (category, index) => {
    const updatedTitles = { ...titles };
    let prev = updatedTitles[category][index].clicked;
    if (Array.isArray(updatedTitles[category])) {
      for (let i = 0; i < updatedTitles[category].length; i++) {
        if (updatedTitles[category][i].clicked) {
          updatedTitles[category][i].clicked = !updatedTitles[category][i].clicked;
        }
      }
    }
    updatedTitles[category][index].clicked = !prev;
    setTitles(updatedTitles);
  };

  const setEqualHeight = () => {
    const columnElements = document.querySelectorAll('.split-experience');
    let maxHeight = 0;

    columnElements.forEach((element) => {
      const height = element.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    columnElements.forEach((element) => {
      element.style.height = `${maxHeight}px!important`;
    });
  };

  useEffect(() => {
    setEqualHeight();
  }, [titles]);


  const generateListItem = (titleList, category) => {
    return (
      <ul>
        {titleList.map((item, index) => (
          <li
            key={index}
            className={`li-main ${item.clicked ? "li-main-clicked" : ""} ${
              index + 1 === titleList.length ? " li-main-last" : ""
            }`}
            onClick={() => handleItemClick(category, index)}
          >
            {item.clicked ? <RiArrowDropDownLine size={20} /> : <RiArrowDropRightLine size={20} />}
            {item.title}
            {item.subTitles.length > 0 && item.clicked && (
              <ol>
                {item.subTitles.map((subItem, subIndex) => (
                  <li key={subIndex} className="li-sub">
                    {subItem.link !== undefined ? <a href={subItem.link} target="_blank" rel="noreferrer"><p style={{"color":"blue", "margin-bottom":"0"}}>{subItem.text}</p></a> : <>{subItem.text}</>}
                  </li>
                ))}
              </ol>
            )}
          </li>
        ))}
      </ul>
    );
  };


  return (<>
    <BrowserView>
      <div className="d-flex">
        <div className="split-experience">
          <div className="title-homelower"><h1>Education</h1></div>
          {generateListItem(titles.education, 'education')}
        </div>
        <div className="split-experience">
          <div className="title-homelower"><h1>Experience</h1></div>
          {generateListItem(titles.experience, 'experience')}
        </div>
        <div className="split-experience">
          <div className="title-homelower"><h1>Projects & More</h1></div>
          {generateListItem(titles.achievements, 'achievements')}
        </div>
      </div>
    </BrowserView>
    <MobileView>
    <div className="mobile-div">
        <div className="mobile-experience">
          <div className="title-homelower"><h1>Education</h1></div>
          {generateListItem(titles.education, 'education')}
        </div>
        <br />
        <div className="mobile-experience">
        <div className="title-homelower"><h1>Experience</h1></div>
          {generateListItem(titles.experience, 'experience')}
        </div>
        <br />
        <div className="mobile-experience">
        <div className="title-homelower"><h1>Projects & More</h1></div>
          {generateListItem(titles.achievements, 'achievements')}
        </div>
      </div>
    </MobileView>
    </>
  );
};

export default HomeLowerPage;
